import "./Merchant.css";
import { useState } from "react";
import {
  getAvilableBalanceName,
  getDailytransactions,
} from "../../../config/LiveApi";
import Spinner from "../../Spin/Spinner";
import ProviderModal from "./ProviderModal";
import DataTable from "../../../components/common/DataTable/DataTable";

function MerchantTable({ inData, isLoading, startDate, endDate }) {
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUserName, setSelectedUserName] = useState("");
  const [transactionData, setTransactionData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loadingBalanceId, setLoadingBalanceId] = useState(null);
  const [liveBalances, setLiveBalances] = useState({});

  // const handleUserClick = async (userId) => {
  //   setSelectedUserId(userId);
  //   try {
  //     const data = await getDailytransactions(userId);
  //     setTransactionData(data);
  //     setShowModal(true);
  //   } catch (error) {
  //     console.error("Error fetching transaction data", error);
  //   }
  // };

  const handleViewBalance = async (name) => {
    try {
      setLoadingBalanceId(name);
      const res = await getAvilableBalanceName(name);
      setLiveBalances((prev) => ({
        ...prev,
        [name]: res,
      }));
      setLoadingBalanceId(null);
    } catch (err) {
      console.error(err);
      setLiveBalances((prev) => ({
        ...prev,
        [name]: "Error",
      }));
      setLoadingBalanceId(null);
    }
  };

  const handleUserClick = async (userId, name) => {
    setSelectedUserId(userId);
    setSelectedUserName(name);
    try {
      const data = await getDailytransactions(userId, startDate, endDate);
      setTransactionData(data);
      setShowModal(true);
    } catch (error) {
      console.error("Error fetching transaction data", error);
    }
  };
  // const handleDateChange = (e) => {
  //   const { name, value } = e.target;
  //   if (name === "startDate") {
  //     setStartDate(value);
  //   } else if (name === "endDate") {
  //     setEndDate(value);
  //   }
  // };

  const formatAmount = (value) => Number(value || 0).toFixed(2);

  const columns = [
    {
      key: "sno",
      header: "S.No",
      render: (_, index) => index + 1,
    },
    {
      key: "name",
      header: "Name",
      render: (row) => (
        <span
          className="user-table-name"
          onClick={() => handleUserClick(row.id, row.name)}
          style={{ cursor: "pointer" }}
        >
          {row.alias || row.id}
        </span>
      ),
    },
    {
      key: "payin",
      header: "Deposit(INR)",
      render: (row) => formatAmount(row.payin),
    },
    {
      key: "payinSuccRate",
      header: "Payin Success Rate(%)",
      wrapHeader: true,
      render: (row) => formatAmount(row.payinSuccRate),
    },
    {
      key: "payinComm",
      header: "Payin Comm(INR)",
      wrapHeader: true,
      render: (row) => formatAmount(row.payinComm),
    },
    {
      key: "payinCommPer",
      header: "Total Payin Comm(%)",
      wrapHeader: true,
      render: (row) => formatAmount(row.payinCommPer),
    },
    {
      key: "rollingReserve",
      header: "Rolling Reserve(INR)",
      wrapHeader: true,
      render: (row) => formatAmount(row.rollingReserve),
    },
    {
      key: "rollingResPer",
      header: "Rolling Reserve(%)",
      wrapHeader: true,
      render: (row) => formatAmount(row.rollingResPer),
    },
    {
      key: "payinNetComm",
      header: "Net Payin Comm(INR)",
      wrapHeader: true,
      render: (row) => formatAmount(row.payinNetComm),
    },
    {
      key: "payout",
      header: "Withdrawal(INR)",
      render: (row) => formatAmount(row.payout),
    },
    {
      key: "payoutSuccRate",
      header: "Payout Success Rate(%)",
      wrapHeader: true,
      render: (row) => formatAmount(row.payoutSuccRate),
    },
    {
      key: "payoutComm",
      header: "Payout Comm(INR)",
      wrapHeader: true,
      render: (row) => formatAmount(row.payoutComm),
    },
    {
      key: "payoutCommPer",
      header: "Total Payout Comm(%)",
      wrapHeader: true,
      render: (row) => formatAmount(row.payoutCommPer),
    },
    {
      key: "payoutNetComm",
      header: "Payout Net Comm(INR)",
      wrapHeader: true,
      render: (row) => formatAmount(row.payoutNetComm),
    },
    {
      key: "reconAmount",
      header: "Recon Amount(INR)",
      wrapHeader: true,
      render: (row) => formatAmount(row.reconAmount),
    },
    {
      key: "recontotalPenalty",
      header: "Total Penalty(INR)",
      wrapHeader: true,
      render: (row) => formatAmount(row.recontotalPenalty),
    },
    {
      key: "availableBalance",
      header: "Available Balance(INR)",
      wrapHeader: true,
      render: (row) =>
        liveBalances[row.id] !== undefined ? (
          formatAmount(liveBalances[row.id])
        ) : (
          <button
            onClick={() => handleViewBalance(row.id)}
            disabled={loadingBalanceId === row.id}
            style={{
              backgroundColor: "#007bff",
              color: "#fff",
              border: "none",
              padding: "4px 8px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            {loadingBalanceId === row.id ? "Loading..." : "View"}
          </button>
        ),
    },
    {
      key: "walletBalance",
      header: "Wallet Balance(INR)",
      wrapHeader: true,
      render: (row) => formatAmount(row.walletBalance),
    },
    {
      key: "time_12am_5am",
      header: "Net Amount 12AM-5AM(INR)",
      wrapHeader: true,
      render: (row) => formatAmount(row.payinTimeBreakdown?.time_12am_5am),
    },
    {
      key: "time_5am_7am",
      header: "Net Amount 5AM-7AM(INR)",
      wrapHeader: true,
      render: (row) => formatAmount(row.payinTimeBreakdown?.time_5am_7am),
    },
    {
      key: "time_7am_1pm",
      header: "Net Amount 7AM-1PM(INR)",
      wrapHeader: true,
      render: (row) => formatAmount(row.payinTimeBreakdown?.time_7am_1pm),
    },
    {
      key: "time_1pm_7pm",
      header: "Net Amount 1PM-7PM(INR)",
      wrapHeader: true,
      render: (row) => formatAmount(row.payinTimeBreakdown?.time_1pm_7pm),
    },
    {
      key: "time_7pm_12am",
      header: "Net Amount 7PM-12AM(INR)",
      wrapHeader: true,
      render: (row) => formatAmount(row.payinTimeBreakdown?.time_7pm_12am),
    },
  ];

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <div
          className="table-main-report"
          style={{
            maxHeight: "650px",
            position: "sticky",
            padding: "0px 10px 0px 10px",
          }}
        >
          <DataTable
            columns={columns}
            data={inData || []}
            loading={isLoading}
            emptyMessage="No Data Found"
          />
        </div>
      )}
      {/* <div className="date-filter">
        <label>Start Date:</label>
        <input type="date" name="startDate" value={startDate} onChange={handleDateChange} />
        <label>End Date:</label>
        <input type="date" name="endDate" value={endDate} onChange={handleDateChange} />
      </div> */}
      {showModal && (
        <ProviderModal
          transactionData={transactionData}
          setShowModal={setShowModal}
          startDate={startDate}
          endDate={endDate}
          userName={selectedUserName}
        />
      )}
    </>
  );
}

export default MerchantTable;
